module.exports = __webpack_public_path__ + "static/media/ronaldo.2cc3df07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/ronaldo.png
// module id = 1437
// module chunks = 0